"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGranularHook_1 = __importDefault(require("./useGranularHook"));
const useGranularEffect = (effect, primaryDeps, secondaryDeps) => (0, useGranularHook_1.default)(react_1.useEffect, effect, primaryDeps, secondaryDeps);
exports.default = useGranularEffect;
